import React, { useCallback, useEffect } from 'react';
import Heading from '@amzn/meridian/heading';
import Column from '@amzn/meridian/column';
import useInlineHelpContentActions from '../hooks/useInlineHelpContentActions';
import useInlineHelpContent from '../hooks/useInlineHelpContent';
import useDownloadTermManualActions from '../hooks/useDownloadTermManualActions';
import LoadingComponent from '../components/atoms/LoadingComponent';
import ContentRenderer from '../components/molecules/ContentRenderer';
import { FOOTER, HEADER, KEY_HEADING, OVERVIEW } from '../constants/common';

interface SheetContentProps {
  pageId: string;
}

const SheetContent: React.FC<SheetContentProps> = ({pageId}) => {

  const { downloadTermManual } = useDownloadTermManualActions();
  const { isLoading } = useInlineHelpContentActions();
  const { response } = useInlineHelpContent();

  if (isLoading) {
    return <LoadingComponent isLoading={isLoading} />;
  }
  
  if (!response) {
    return null;
  }

  
  const parsedResponse = JSON.parse(response);
  const propertyNames = Object.keys(parsedResponse);

  const renderSheetContent = (keyNames: string[]) => {
    let sheetContent: React.JSX.Element[] = [];
    const keyProperties = keyNames;
    if (keyNames.includes(HEADER)) {
      sheetContent.push(<Heading level={1}>{parsedResponse?.header}</Heading>);
    }

    // Swapping to maintain overview and keyTerm order
    if (keyNames.includes(OVERVIEW) && keyNames.includes(KEY_HEADING)) {
      const overviewIndex = keyNames.indexOf(OVERVIEW);
      keyProperties[keyNames.indexOf(KEY_HEADING)] = OVERVIEW;
      keyProperties[overviewIndex] = KEY_HEADING;
    }

    sheetContent = [
      ...sheetContent,
      ...keyProperties.filter((keyName) => keyName.toLowerCase() !== HEADER && keyName.toLowerCase() !== FOOTER).map((propertyName) => {
        const propertyValues = JSON.parse(parsedResponse[propertyName]);
        return (<ContentRenderer 
          title={propertyValues.title} 
          contentType={propertyValues.contentType} 
          content={propertyValues.content} 
          onDownloadBtnClick={(termKey: string) => downloadTermManual(termKey)}/>);
  
      })
    ];

    if (keyNames.includes(FOOTER)) {
      const propertyValues = JSON.parse(parsedResponse.footer);
      sheetContent.push(<ContentRenderer 
        title={propertyValues.title} 
        contentType={propertyValues.contentType} 
        content={propertyValues.content} 
        onDownloadBtnClick={(termKey: string) => downloadTermManual(termKey)}/>);
    }

    return sheetContent;
  };

  return (
    <Column>
      {renderSheetContent(propertyNames.sort())}
    </Column>
  );
};

export default SheetContent;